export const offer = {
  name: 'Tap Dance Teacher Ready',
  tagline: 'The Complete 6-in-1 Teaching System',
  checkoutUrl: 'https://tap-dance-teacher-ready.impultienda.ar/checkout',
  packImage:
    'https://cdn.magicpatterns.com/uploads/euTDiv8RxoNf9EqqB2KJgL/Diseno_sin_titulo_(62).png',
  todayPrice: 'USD $27',
  ctaPrimary: 'GET TAP DANCE TEACHER READY NOW',
  ctaOffer: 'GET THE COMPLETE TAP DANCE TEACHING SYSTEM NOW',
}

export const heroHighlights = [
  '6 complete teaching volumes in one system',
  '150 ready-to-teach classes',
  '3 professional visual handbooks',
  '5 premium bonuses',
  'Immediate access',
]

export const realCosts = [
  'Hours spent searching for drills and combinations',
  'Repeating the same exercises because they are already familiar',
  'Classes that lack a clear technical progression',
  'Difficulty deciding when students are ready to advance',
  'Rhythm and musicality work that becomes improvised',
  'Students who practice steps without fully understanding timing',
  'Constantly rewriting combinations for different levels',
  'Limited time to work on corrections and individual development',
  'Stress when a class plan suddenly stops working',
  'Last-minute preparation before performances and recitals',
  'No consistent system for assessment and student progress',
  'Valuable evenings and weekends lost preparing lessons',
]

export const systemParts = [
  {
    number: '1',
    title: 'Foundation',
    description: 'Build correct technique.',
  },
  {
    number: '2',
    title: 'Beginner Curriculum',
    description: 'Create a logical starting pathway.',
  },
  {
    number: '3',
    title: 'Intermediate Development',
    description: 'Build greater rhythmic and technical complexity.',
  },
  {
    number: '4',
    title: 'Advanced Training',
    description: 'Develop speed, power, precision, and performance.',
  },
  {
    number: '5',
    title: 'Musical & Creative Development',
    description: 'Teach rhythm, musicality, and improvisation.',
  },
  {
    number: '6',
    title: 'Complete Class System',
    description:
      'Turn everything into 150 ready-to-teach lessons with planning and assessment support.',
  },
]

export const handbooks = [
  {
    id: 'Visual Handbook 1',
    title: 'Tap Technique Visual Atlas',
    description:
      'A professional visual reference for technique, movement breakdowns, corrections, progressions, and instructional application.',
    usage:
      'Use it when you need to quickly review how a movement should be taught, what to observe, and how to progress it.',
  },
  {
    id: 'Visual Handbook 2',
    title: 'Tap Rhythm, Musicality & Combination Visual Handbook',
    description:
      'A visual system for rhythm, subdivisions, syncopation, phrasing, musicality, combination construction, and creative Tap instruction.',
    usage:
      'Use it to make rhythmic ideas easier to understand, organize, and teach.',
  },
  {
    id: 'Visual Handbook 3',
    title: 'Tap Teacher Quick-Reference Visual Toolkit',
    description:
      'A rapid-reference system for student placement, lesson selection, corrections, progressions, assessment, and real-world class planning.',
    usage: 'Use it whenever you need to make a teaching decision quickly.',
  },
]

export const includes = [
  '6 complete professional teaching volumes',
  '150 ready-to-teach Tap Dance classes',
  'Beginner through advanced progression',
  'Technique development',
  'Rhythm training',
  'Musicality instruction',
  'Improvisation systems',
  'Performance preparation',
  'Assessment tools',
  'Student progression systems',
  'Class-planning support',
  'Teacher cues and corrections',
  '3 professional visual handbooks',
  '5 premium bonus resources',
  'Immediate access',
  '7-day money-back guarantee',
]

export const frictionPoints = [
  'No more spending evenings searching for one more drill',
  'No more wondering whether the class progression makes sense',
  'No more repeating combinations simply because you do not have time to prepare something different',
  'No more improvising rhythm work',
  'No more guessing what students should learn next',
  'No more scrambling when your original lesson plan fails',
  'No more trying to organize recital preparation at the last minute',
  'No more wondering whether your students are actually progressing',
]

export const checklistGroups = [
  {
    title: '6-in-1 Core System',
    items: [
      'Volume 1: Tap Foundations & Core Technique',
      'Volume 2: Beginner Tap Curriculum & Class System',
      'Volume 3: Intermediate Tap Technique, Rhythm & Musicality',
      'Volume 4: Advanced Tap Technique, Speed, Power & Performance',
      'Volume 5: Rhythm, Musicality, Improvisation & Creative Tap Mastery',
      'Volume 6: Complete Teaching System, 150 Lessons, Assessment & Class Planning',
    ],
  },
  {
    title: '3 Professional Visual Handbooks',
    items: [
      'Visual Handbook 1: Tap Technique Visual Atlas',
      'Visual Handbook 2: Tap Rhythm, Musicality & Combination Visual Handbook',
      'Visual Handbook 3: Tap Teacher Quick-Reference Visual Toolkit',
    ],
  },
  {
    title: '5 Premium Bonuses',
    items: [
      'Bonus 1: Tap Teacher Correction, Cueing & Troubleshooting Mastery',
      'Bonus 2: Tap Class Rescue Vault — 75 Ready-to-Teach Emergency, Substitute & Low-Prep Tap Classes',
      'Bonus 3: Tap Performance, Recital & Stage Preparation System',
      'Bonus 4: 150 Tap Games, Challenges & Creative Class Activities Vault',
      'Bonus 5: Tap Instructor Business, Student Retention & Studio Growth Toolkit',
    ],
  },
  {
    title: 'Plus',
    items: [
      '150 Ready-to-Teach Classes',
      'Beginner to Advanced Coverage',
      'Immediate Access',
      '7-Day Money-Back Guarantee',
      'Worldwide Access',
      'Pay in Your Local Currency',
    ],
  },
]
